import { useState } from 'react';
import { Trans } from '@lingui/macro';
import { Button } from '@material-ui/core';

import { isFunction } from 'lodash';

import PropTypes from 'prop-types';
import DataTableActionDialog from './DataTableActionDialog';

export default function ConfirmDataTableActionButton({
    handleConfirmedDataTableAction,
    disabled = false,
    plural = false,
    needConfirm,
    label = label || `Data Table Action`,
    confirmMsg,
}) {
    const [showConfirmationDialog, setShowConfirmationDialog] = useState(false);
    const isNeedConfirm = isFunction(needConfirm) ? needConfirm() : needConfirm;

    const handleRequestedDataTableAction = (event) => {
        event?.currentTarget.blur();
        setShowConfirmationDialog(true);
    };

    return (
        <>
            <Button
                onClick={isNeedConfirm ? handleRequestedDataTableAction : handleConfirmedDataTableAction}
                disabled={disabled}
            >
                {label}
            </Button>
            <DataTableActionDialog
                plural={plural}
                open={showConfirmationDialog}
                setOpen={setShowConfirmationDialog}
                onConfirm={handleConfirmedDataTableAction}
                label={label}
                confirmMsg={confirmMsg}
            />
        </>
    );
}

ConfirmDataTableActionButton.propTypes = {
    handleConfirmedDataTableAction: PropTypes.func,
    disabled: PropTypes.bool,
    plural: PropTypes.bool,
    label: PropTypes.oneOfType([PropTypes.element, PropTypes.string]),
    needConfirm: PropTypes.oneOfType([PropTypes.bool, PropTypes.func]),
    confirmMsg: PropTypes.oneOfType([PropTypes.element, PropTypes.func]),
};

ConfirmDataTableActionButton.defaultProps = {
    handleConfirmedDataTableAction: () => {},
    disabled: false,
    plural: false,
    label: <Trans>Data Table Action</Trans>,
    needConfirm: false,
    confirmMsg: null,
};
